import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";

const RunningHours = (props) => {
  const { runninghours } = props;
  return (
    <Card {...props} sx={{ height: '100%' }}>
      <CardContent sx={{ px: { xs: 1.5, sm: 2 }, py: { xs: 1.25, sm: 1.75 } }}>
        <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12}>
            <Typography color="textSecondary" gutterBottom variant="h6" sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}>
              LAB RUNNING DURATIONS
            </Typography>
            <Typography color="textPrimary" variant="h3" sx={{ fontSize: { xs: '1.6rem', sm: '2rem' }, lineHeight: 1.2 }}>
              {runninghours} Minutes
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default RunningHours;